import type { ICouponClaim } from "@api/models/IClaim";
import { Stack } from "@mantine/core";
import CopyText from "@modules/clientDashboard/components/CopyText";
import ContainerText from "@modules/clientDashboard/components/container/ContainerText";

interface ICouponModalBodyProps {
  item: ICouponClaim;
}

const CouponModalBody: React.FC<ICouponModalBodyProps> = ({ item }) => {
  return (
    <Stack className="items-center">
      <ContainerText className="!rounded text-pretty bg-primary-default text-center font-bold">
        Voici ton code de réduction de 5€ :
      </ContainerText>
      <CopyText
        className="!font-bold !text-primary-white h-14 rounded bg-primary-default text-lg"
        w={"fit-content"}
        value={item.code}
      >
        {item.code}
      </CopyText>
      <ContainerText className="!rounded bg-primary-default text-center">
        Minimum de 10€ d'achat pour l'utiliser.
      </ContainerText>
    </Stack>
  );
};

export default CouponModalBody;
